module.exports = __webpack_public_path__ + "static/media/image-6.6978c02a.jpg";